import axios from 'axios'
import { GET_ALL_TS_DEALERS, LOADING, GET_SINGLE_TS_DEALER } from './types'
import { GET_CONTACT, RESET_CONTACT } from '../../Contacts/redux/types'
import { notificationSuccess } from '../../../utils/customToastify'

export const getDuplicates = (filter) => async () => {
  const response = await axios.get('/ts-dealers/get-duplicates', {
    params: { filter },
  })
  return response.data
}

export const getAllTSDealers = (options) => async (dispatch) => {
  dispatch(setLoading())
  const response = await axios.get('/ts-dealers', { params: { ...options } })
  dispatch({ type: GET_ALL_TS_DEALERS, payload: response.data })
}

export const getTSDealer = (contactId) => async (dispatch) => {
  dispatch(setLoading())
  const response = await axios.get(`/ts-dealers/${contactId}`)
  dispatch({ type: GET_SINGLE_TS_DEALER, payload: response.data })
  // ContactHeader i HistoryDetailsTabs citaju state.contacts.contact, ne propove -
  // isti razlog zbog kog FinanceDealers puni contacts slice (financeDealersActions.getDealer)
  dispatch({ type: GET_CONTACT, payload: response.data })
}

export const resetTSDealer = () => (dispatch) => {
  dispatch({ type: RESET_CONTACT, payload: {} })
}

export const createTSDealer = (data, history) => async (dispatch) => {
  dispatch(setLoading())
  const response = await axios.post('/ts-dealers', data)
  notificationSuccess('Dealer successfuly created.')
  history.push(`/ts-dealers/${response.data.id}`)
}

export const updateTSDealer = (id, data) => async (dispatch) => {
  dispatch(setLoading())
  const response = await axios.patch(`/ts-dealers/${id}`, data)
  notificationSuccess('Dealer successfuly updated.')
  dispatch({ type: GET_SINGLE_TS_DEALER, payload: response.data })
  dispatch({ type: GET_CONTACT, payload: response.data })
}

const setLoading = () => ({
  type: LOADING,
})
